/* eslint-disable */
import axios from 'axios';
// import store from '@/store'
// import { getToken } from '@/utils/auth'
// let base_url;
// if (process.env.NODE_ENV === 'production') {
//   base_url = ''
// } else if (process.env.NODE_ENV === 'development') {
//   base_url = ''
// }
import store from '@/store';
import { getToken, removeToken } from '@/utils/auth';

import Vue from 'vue';

import { Notification, MessageBox, Message } from 'element-ui';

// 第三方插件

Vue.prototype.$axios = axios;
// 字体图标
// http://121.5.181.214
const service = axios.create({
  baseURL: '/walimanage/',
  // timeout: 50000,
  timeout: 600000,
  headers: {}
});
service.defaults.withCredentials = false; // 让ajax携带cookie
service.interceptors.request.use(
  // 每次请求都自动携带Cookie
  config => {
    if (getToken()) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['Authorization'] = getToken();
    }

    return config;
  },
  // eslint-disable-next-line handle-callback-err
  error => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => response.data,

  // (rsp) => {
  //   let data = rsp.data;
  //   if (!data.success) {
  //     Notification.error({
  //       title: '系统提示',
  //       message: data.message || data.error || '请求失败',
  //       duration: 3000,
  //     });
  //   }
  //   return rsp.data;
  // },
  // 拦截异常的响应
  err => {
    console.log('请求', err);
    let data = err.response.data;
    if (data.code == 510) {
      MessageBox.alert('未授权，请重新登录', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        callback: action => {
          store.dispatch('Logout').then(() => {
            removeToken();
            window.location.reload();
          });
        }
      });
      return Promise.reject(err);
    }

    switch (err.response.status) {
      case 401:
        MessageBox.alert('未授权，请重新登录');
        break;
      case 403:
        Message.warning('拒绝访问');
        break;
      case 500:
        Notification.error({
          title: '系统提示',
          message: '服务器出了点小错误'
        });
        break;
      case 404:
        Notification({
          title: '系统提示',
          message: '很抱歉，资源未找到!',
          type: 'warning'
        });
        break;
      case 510:
        Notification({
          title: '系统提示',
          message: 'what!',
          type: 'warning'
        });
        break;
      default:
        Notification.error({
          title: '系统提示',
          message: data.message || data.error,
          duration: 3000
        });
        break;
    }
    //throw 'request error'
    return Promise.reject(err);
  }
);

export default service;
